import Layers from "../../../../../../src/layers/Layers";
import Angle from "../../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../../src/types/Interface";
import { BLUE_ANGLE_COLORS, PINK_ANGLE_COLORS } from "../../types/Config";
import { drawAngle } from "./helpers/drawHelpers";
import { AngleDrawParams } from "../../types/Interface";
import { generateAnglePoints } from "./helpers/generateAnglePoints";
import { areCoordsEqual } from "../../../../../../src/utils/coord/areCoordsEqual";
import { generateAngles } from "../../../../../../src/utils/generator/generateAngles";
import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";


export default class AngleManager {
  private Layers = Layers.getInstance();

  circumAnglePink = new Angle("circumPink", { color: PINK_ANGLE_COLORS[0], textColor: PINK_ANGLE_COLORS[1] });
  circumAngleBlue = new Angle("circumBlue", { color: BLUE_ANGLE_COLORS[0], textColor: BLUE_ANGLE_COLORS[1] });
  alternativeAnglePink = new Angle("alternativePink", { color: PINK_ANGLE_COLORS[0], textColor: PINK_ANGLE_COLORS[1] }, 10, true);
  alternativeAngleBlue = new Angle("alternativeBlue", { color: BLUE_ANGLE_COLORS[0], textColor: BLUE_ANGLE_COLORS[1] }, 10, true);

  private isShownSecondSegment = true;

  private currPoints: Coord[] = [];
  private currDegrees: number[] = [];

  constructor() {
    this.Layers.Top.addChild(this.alternativeAnglePink);
    this.Layers.Top.addChild(this.alternativeAngleBlue);

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false))
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true))
  }
  setVisibles(status: boolean) {
    this.setAllVisible(status);
    this.setIsShownSecondSegment(false)
  }
  setAllVisible(status: boolean) {
    [this.circumAnglePink, this.alternativeAnglePink, this.circumAngleBlue, this.alternativeAngleBlue]
      .forEach(angle => angle.setVisible(status))
  }
  setIsShownSecondSegment(v: boolean) {
    this.isShownSecondSegment = !v;
    [this.circumAnglePink, this.alternativeAnglePink].forEach(angle => {
      angle.visible = !v;
      angle.AngleValue.visible = !v;
    })
  }
  draw(points: Coord[], tangentCoords: Coord[], sltdTPIndex: number, clockwise: boolean) {
    const sI = sltdTPIndex;
    const pL = points.length;
    const bI = sI != pL - 1 ? sI + 1 : 0;
    const pI = sI != 0 ? sI - 1 : pL - 1;
    const angleParams = this.generateAngleParams(points.map(p => ({ x: p.x, y: p.y })), sI, clockwise);

    const blueP = { curr: points[sI], prev: tangentCoords[clockwise ? 0 : 1], next: points[pI] };
    const blueDetail = generateAngles(blueP, !clockwise);

    const alternatifParamsB = {
      startRadian: blueDetail.startRadian,
      endRadian: blueDetail.endRadian,
      degree: angleParams[bI].degree,
      points: blueP
    }

    drawAngle(this.circumAngleBlue, angleParams[bI], clockwise);
    drawAngle(this.alternativeAngleBlue, alternatifParamsB, clockwise);

    if (this.isShownSecondSegment) {
      const pinkP = !clockwise ? { curr: points[sI], prev: tangentCoords[0], next: points[bI] } : { curr: points[sI], prev: points[bI], next: tangentCoords[1] }
      const pinkDetail = generateAngles(pinkP, clockwise);

      const alternatifParams = {
        startRadian: pinkDetail.startRadian,
        endRadian: pinkDetail.endRadian,
        degree: angleParams[pI].degree,
        points: pinkP
      }

      drawAngle(this.circumAnglePink, angleParams[pI], clockwise);
      drawAngle(this.alternativeAnglePink, alternatifParams, true);
    }
  }

  generateAngleParams(points: Coord[], sI: number, clockwise: boolean): AngleDrawParams[] {
    const anglePoints = generateAnglePoints(points);
    const params = anglePoints.map(obj => {
      const angles = generateAngles(obj, clockwise);
      return {
        points: obj,
        startRadian: angles.startRadian,
        endRadian: angles.endRadian,
        degree: angles.degree
      }
    })

    if (!areCoordsEqual(this.currPoints, points)) {
      this.currPoints = points;
      const otherIndex = [0, 1, 2].filter(i => i != sI);
      const twoDegree = params[otherIndex[0]].degree + params[otherIndex[1]].degree;
      params[sI].degree = 180 - twoDegree;
      this.currDegrees = params.map(p => p.degree);
    } else {
      params.forEach((param, pI) => param.degree = this.currDegrees[pI]);
    }
    return params;
  }
}